document.addEventListener('DOMContentLoaded', function () {
    const simulatorDropdown = document.querySelector(
        '.simulator-taxonomy-dropdown'
    );

    if (!simulatorDropdown) {
        return;
    }

    // Formateo visual de campos numéricos con separador de miles colombiano
    const currencyFieldSelectors = [
        '.gf-monthly-income input',
        '.gf-down-payment-amount input'
    ];

    function formatWithDots(value) {
        var rawValue = value.replace(/[^0-9]/g, '');
        return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // Limpiar valores formateados para GF (poner valor numérico puro)
    function cleanCurrencyFields() {
        currencyFieldSelectors.forEach(function(selector) {
            var field = document.querySelector(selector);
            if (field && field.dataset.rawValue) {
                field.value = field.dataset.rawValue;
            }
        });
    }

    // Restaurar el formateo visual después de que GF procese
    function restoreCurrencyFormatting() {
        currencyFieldSelectors.forEach(function(selector) {
            var field = document.querySelector(selector);
            if (field && field.dataset.rawValue) {
                field.value = formatWithDots(field.dataset.rawValue);
            }
        });
    }

    function setupCurrencyFormatting() {
        currencyFieldSelectors.forEach(function(selector) {
            const field = document.querySelector(selector);
            if (!field) return;

            field.setAttribute('type', 'text');
            field.setAttribute('inputmode', 'numeric');

            // Guardar el valor raw en un data attribute
            field.addEventListener('input', function() {
                var cursorPos = this.selectionStart;
                var oldLength = this.value.length;

                var rawValue = this.value.replace(/[^0-9]/g, '');
                this.dataset.rawValue = rawValue;

                var formatted = formatWithDots(this.value);
                this.value = formatted;

                var newLength = this.value.length;
                var newCursorPos = cursorPos + (newLength - oldLength);
                this.setSelectionRange(newCursorPos, newCursorPos);
            });

            // Restaurar el valor formateado después de que GF lo limpie en blur/change
            field.addEventListener('blur', function() {
                var raw = this.dataset.rawValue;
                if (raw) {
                    var self = this;
                    setTimeout(function() {
                        if (self.value !== formatWithDots(raw) && raw !== '') {
                            self.value = formatWithDots(raw);
                        }
                    }, 50);
                }
            });

            field.addEventListener('change', function() {
                var raw = this.dataset.rawValue;
                if (raw) {
                    var self = this;
                    setTimeout(function() {
                        if (self.value !== formatWithDots(raw) && raw !== '') {
                            self.value = formatWithDots(raw);
                        }
                    }, 50);
                }
            });
        });

        // Limpiar valores ANTES de que GF valide al hacer clic en "Siguiente"
        var btnSiguiente = document.querySelector('button[data-step="3"]');
        if (btnSiguiente) {
            btnSiguiente.addEventListener('click', function() {
                cleanCurrencyFields();
            }, true); // true = fase de captura, se ejecuta ANTES que los demás listeners
        }
    }

    setupCurrencyFormatting();

    const vehicleButtons = document.querySelectorAll('.select-vehicle-item');
    const btnSiguienteStep1 = document.querySelector('button[data-step="2"]');
    const vehiclesContainer = document.querySelector('.vehicles-container');

    const nonce = window.ajax_object ? window.ajax_object.nonce : '';

    if (!nonce) {
        return;
    }

    function reinitializeTelephoneFields() {
        // Wait a bit for the DOM to be fully updated
        setTimeout(() => {
            // Try multiple approaches to reinitialize telephone fields

            // Method 1: If the plugin exposes a global initialization function
            if (typeof window.initTelephoneFields === 'function') {
                window.initTelephoneFields();
            }

            // Method 2: If using intl-tel-input library directly
            if (typeof window.intlTelInput !== 'undefined') {
                const telephoneInputs = document.querySelectorAll('input[type="tel"]');
                telephoneInputs.forEach(input => {
                    // Destroy existing instance if any
                    if (input.intlTelInput) {
                        input.intlTelInput.destroy();
                    }
                    // Reinitialize
                    window.intlTelInput(input, {
                        // Add common configuration options
                        separateDialCode: true,
                        nationalMode: false,
                        autoPlaceholder: "aggressive",
                        preferredCountries: ['co', 'us', 've', 'ec', 'pe']
                    });
                });
            }

            // Method 3: Trigger custom events that the plugin might listen to
            const telephoneFields = document.querySelectorAll('.gfield_telephone, input[type="tel"]');
            telephoneFields.forEach(field => {
                // Trigger events that might reinitialize the plugin
                field.dispatchEvent(new Event('change'));
                field.dispatchEvent(new Event('focus'));
                field.dispatchEvent(new Event('blur'));
            });

            // Method 4: If the plugin has specific CSS classes, trigger reinitialization
            const gfTelFields = document.querySelectorAll('.gf_telephone_field, .ginput_container_telephone');
            if (gfTelFields.length > 0 && typeof jQuery !== 'undefined') {
                jQuery(gfTelFields).trigger('gform_post_render');
            }

            // Method 5: Trigger Gravity Forms post render hook
            if (typeof gform !== 'undefined' && typeof gform.doAction === 'function') {
                try {
                    gform.doAction('gform_post_render', document.querySelector(`#gform_${simulator_config.form_id}`), simulator_config.form_id);
                } catch (e) {
                    console.log('gform.doAction error:', e);
                }
            }

            // Method 6: For some plugins that listen to document ready
            if (typeof jQuery !== 'undefined') {
                jQuery(document).ready(function () {
                    jQuery('input[type="tel"]').trigger('ready');
                });
            }

        }, 100);
    }

    function removeActiveClass() {
        const allVehicleButtons = document.querySelectorAll('.select-vehicle-item');
        allVehicleButtons.forEach((button) => {
            button.classList.remove('active');
        });
    }

    function toggleNextButton() {
        if (window.selectedVehicle) {
            btnSiguienteStep1.disabled = false;
            btnSiguienteStep1.classList.remove(
                'opacity-50',
                'cursor-not-allowed'
            );
            btnSiguienteStep1.classList.add(
                'hover:bg-transparent',
                'hover:text-(--primary-color)'
            );
        } else {
            btnSiguienteStep1.disabled = true;
            btnSiguienteStep1.classList.add('opacity-50', 'cursor-not-allowed');
            btnSiguienteStep1.classList.remove(
                'hover:bg-transparent',
                'hover:text-(--primary-color)'
            );
        }
    }

    toggleNextButton();

    function scrollToNextButton() {
        // Solo en mobile (767px para abajo)
        if (window.innerWidth <= 767) {
            const nextButton = document.querySelector('button[data-step="2"]');
            if (nextButton) {
                nextButton.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
    }

    function showLoader() {
        let loader = document.getElementById('category-loader');

        if (!loader) {
            loader = document.createElement('div');
            loader.id = 'category-loader';
            loader.className = 'fixed top-0 left-0 w-full h-full z-[9999] flex items-center justify-center bg-white/95';
            loader.innerHTML = `
                <div class="flex flex-col items-center gap-6">
                    <div class="w-16 h-16 border-4 border-gray-200 border-t-[var(--primary-color)] rounded-full animate-spin"></div>
                    <div class="text-[1.6rem] font-semibold text-[var(--primary-color)] tracking-wider">Cargando...</div>
                </div>
            `;
            document.body.appendChild(loader);
        }

        loader.classList.remove('hidden');
        loader.style.display = 'flex';

        // Block scroll on both body and html
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
    }

    function hideLoader() {
        const loader = document.getElementById('category-loader');
        if (loader) {
            loader.classList.add('hidden');
            loader.style.display = 'none';
        }

        // Restore scroll on both body and html
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden');
    }

    function loadVehiclesByTaxonomy(taxonomyId, autoSelectVehicleId = null) {
        // Show loader
        showLoader();

        // Track the start time to ensure minimum display time
        const startTime = Date.now();
        const minimumLoadingTime = 500; // 500ms minimum

        const formData = new FormData();
        formData.append('action', 'get_vehicles_by_taxonomy_simulator');
        formData.append('taxonomy_id', taxonomyId);
        formData.append('nonce', nonce);

        fetch(window.ajax_object.ajax_url, {
            method: 'POST',
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                try {
                    const data = JSON.parse(text);
                    if (data.success) {
                        console.log('#vehicles', data.data)

                        // Calculate remaining time to reach minimum loading time
                        const elapsedTime = Date.now() - startTime;
                        const remainingTime = Math.max(0, minimumLoadingTime - elapsedTime);

                        // Wait for minimum time before updating UI
                        setTimeout(() => {
                            updateVehiclesContainer(data.data);

                            if (autoSelectVehicleId) {
                                setTimeout(() => {
                                    const vehicleButton = document.querySelector(`.select-vehicle-item[data-vehicle-id="${autoSelectVehicleId}"]`);

                                    if (vehicleButton) {
                                        vehicleButton.click();

                                        // Avanzar automáticamente al paso 2
                                        setTimeout(() => {
                                            if (btnSiguienteStep1 && !btnSiguienteStep1.disabled) {
                                                btnSiguienteStep1.click();
                                            }
                                        }, 300);
                                    }
                                }, 100);
                            }

                            // Hide loader after updating UI
                            hideLoader();
                        }, remainingTime);
                    }
                } catch (parseError) {
                    console.error('Error parseando respuesta:', text);
                    // Calculate remaining time even on error
                    const elapsedTime = Date.now() - startTime;
                    const remainingTime = Math.max(0, minimumLoadingTime - elapsedTime);

                    setTimeout(() => {
                        hideLoader();
                    }, remainingTime);
                }
            })
            .catch((error) => {
                console.error('Error en la petición:', error);
                // Calculate remaining time even on error
                const elapsedTime = Date.now() - startTime;
                const remainingTime = Math.max(0, minimumLoadingTime - elapsedTime);

                setTimeout(() => {
                    hideLoader();
                }, remainingTime);
            });
    }

    function updateVehiclesContainer(vehicles) {
        if (!vehiclesContainer) return;

        vehiclesContainer.innerHTML = '';

        vehicles.forEach((vehicle, index) => {
            const vehicleButton = document.createElement('button');
            vehicleButton.className =
                'duration-150 border border-(--secondary-v2-color) cursor-pointer select-vehicle-item';
            vehicleButton.setAttribute('data-vehicle-id', vehicle.id);
            vehicleButton.setAttribute('data-price', vehicle.price);

            vehicleButton.setAttribute('data-vehicle-name', vehicle.name);
            vehicleButton.setAttribute('data-vehicle-image', vehicle.image);

            vehicleButton.setAttribute('data-vehicle-price-text', vehicle.price_text);
            vehicleButton.setAttribute('data-vehicle-price', vehicle.price);
            vehicleButton.setAttribute('data-vehicle-price-formatted', vehicle.price_formatted);

            vehicleButton.innerHTML = `
                <p class="py-7 duration-150 uppercase font-(family-name:--font-russo) text-[2.1rem] text-center border-b border-(--secondary-v2-color) select-vehicle-item-name">${vehicle.name}</p>
                <div class="h-[23rem] [&_img]:w-full [&_img]:h-full [&_img]:object-contain p-2 select-vehicle-item-image">
                    <img src="${vehicle.image}" alt="${vehicle.name}">
                </div>
                <div class="py-4 text-center">
                    <span class="text-[1.6rem] font-semibold text-[#565656] select-vehicle-item-price">${vehicle.price_text}</span>
                </div>
            `;

            vehiclesContainer.appendChild(vehicleButton);
        });

        reassignVehicleButtonListeners();
    }

    function reassignVehicleButtonListeners() {
        const newVehicleButtons = document.querySelectorAll(
            '.select-vehicle-item'
        );

        newVehicleButtons.forEach((button) => {
            button.addEventListener('click', function () {
                removeActiveClass();
                this.classList.add('active');

                const vehicleId = this.getAttribute('data-vehicle-id');
                const vehicleName = this.querySelector(
                    '.select-vehicle-item-name'
                ).textContent;
                const vehicleImage = this.querySelector(
                    '.select-vehicle-item-image img'
                ).src;
                const vehiclePrice = this.getAttribute('data-vehicle-price');
                const vehiclePriceText = this.getAttribute('data-vehicle-price-text');
                const vehiclePriceFormatted = this.getAttribute('data-vehicle-price-formatted');

                window.selectedVehicle = {
                    id: vehicleId,
                    name: vehicleName,
                    image: vehicleImage,

                    price: vehiclePrice,
                    price_text: vehiclePriceText,
                    price_formatted: vehiclePriceFormatted
                };

                toggleNextButton();

                // Avanzar automáticamente al paso 2 después de seleccionar el vehículo
                setTimeout(() => {
                    if (btnSiguienteStep1 && !btnSiguienteStep1.disabled) {
                        btnSiguienteStep1.click();
                    }
                }, 300);
            });
        });
    }

    function updateMenuStep(stepNumber) {
        const menuSteps = document.querySelectorAll(
            '.menu-simulator-step span'
        );
        menuSteps.forEach((span, index) => {
            if (index + 1 === stepNumber) {
                span.classList.add('active');
            } else {
                span.classList.remove('active');
            }
        });
    }

    if (simulatorDropdown) {
        const dropdownOptions =
            simulatorDropdown.querySelectorAll('.dropdown-option');

        dropdownOptions.forEach((option) => {
            option.addEventListener('click', function () {
                const taxonomyId = this.getAttribute('data-value');
                const taxonomyName = this.textContent;

                const placeholder = simulatorDropdown.querySelector(
                    '.dropdown-placeholder'
                );
                if (placeholder) {
                    placeholder.textContent = taxonomyName;
                }

                loadVehiclesByTaxonomy(taxonomyId);

                window.selectedVehicle = null;
                toggleNextButton();
            });
        });
    }

    // Inicializar simulador
    if (simulatorDropdown) {
        // Si hay un vehículo preseleccionado por URL (vid), cargar su taxonomía primero
        if (window.simulatorConfig && window.simulatorConfig.vehicleId && window.simulatorConfig.preselectedTaxonomyId) {
            const preselectedOption = simulatorDropdown.querySelector(`.dropdown-option[data-value="${window.simulatorConfig.preselectedTaxonomyId}"]`);

            if (preselectedOption) {
                // Actualizar el placeholder del dropdown
                const placeholder = simulatorDropdown.querySelector('.dropdown-placeholder');
                if (placeholder) {
                    placeholder.textContent = preselectedOption.textContent;
                }

                // Cargar vehículos de esa taxonomía y auto-seleccionar el vehículo
                loadVehiclesByTaxonomy(window.simulatorConfig.preselectedTaxonomyId, window.simulatorConfig.vehicleId);
            }
        } else {
            // Comportamiento por defecto: cargar la primera opción
            const firstOption = simulatorDropdown.querySelector('.dropdown-option');
            if (firstOption) {
                firstOption.click();
            }
        }
    }

    vehicleButtons.forEach((button) => {
        button.addEventListener('click', function () {
            removeActiveClass();
            this.classList.add('active');

            const vehicleId = this.getAttribute('data-vehicle-id');
            const vehicleName = this.querySelector(
                '.select-vehicle-item-name'
            ).textContent;
            const vehicleImage = this.querySelector(
                '.select-vehicle-item-image img'
            ).src;

            window.selectedVehicle = {
                id: vehicleId,
                name: vehicleName,
                image: vehicleImage
            };

            toggleNextButton();

            // Avanzar automáticamente al paso 2 después de seleccionar el vehículo
            setTimeout(() => {
                if (btnSiguienteStep1 && !btnSiguienteStep1.disabled) {
                    btnSiguienteStep1.click();
                }
            }, 300);
        });
    });

    const step1 = document.getElementById('step-1');
    const step2 = document.getElementById('step-2');
    const step3 = document.getElementById('step-3');

    if (step1 && step2 && step3) {
        if (btnSiguienteStep1) {
            btnSiguienteStep1.addEventListener('click', function () {
                if (!window.selectedVehicle) {
                    const firstVehicle = document.querySelector(
                        '.select-vehicle-item'
                    );
                    if (firstVehicle) {
                        firstVehicle.click();
                    }
                }

                step1.classList.add('hidden');
                step2.classList.remove('hidden');
                updateMenuStep(2);

                if (window.innerWidth <= 767) {
                    setTimeout(() => {
                        step2.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }, 500);
                }

                if (window.selectedVehicle) {
                    const vehicleNameElement = step2.querySelector('.vehicle-name');
                    const vehicleImageElement = step2.querySelector('.vehicle-image');
                    const vehiclePriceElement = step2.querySelector('.vehicle-price');

                    if (vehicleNameElement) {
                        vehicleNameElement.textContent = window.selectedVehicle.name;
                    }
                    if (vehicleImageElement) {
                        vehicleImageElement.src = window.selectedVehicle.image;
                    }
                    if (vehiclePriceElement && window.selectedVehicle.price_text) {
                        vehiclePriceElement.textContent = window.selectedVehicle.price_text;
                    }
                }
            });
        }

        const btnAtrasStep2 = step2.querySelector('button[data-step="1"]');
        if (btnAtrasStep2) {
            btnAtrasStep2.addEventListener('click', function () {
                step2.classList.add('hidden');
                step1.classList.remove('hidden');
                updateMenuStep(1);
            });
        }

        const btnSiguienteStep2 = step2.querySelector('button[data-step="3"]');
        if (btnSiguienteStep2) {
            btnSiguienteStep2.addEventListener('click', function (e) {
                e.preventDefault();

                const gravityForm = step2.querySelector('form');

                if (gravityForm) {
                    function cleanCurrencyValue(value) {
                        if (!value) return 0;

                        let cleanValue = value.toString()
                            .replace(/\$/g, '')  // Remove $ symbol
                            .replace(/\s/g, '')  // Remove spaces
                            .trim();

                        // Detectar formato: si tiene comas seguidas de 3 dígitos, las comas son separadores de miles (formato US/Gravity)
                        // Ejemplo: 69,630,000.00 -> comas son miles, punto es decimal
                        // Si tiene puntos seguidos de 3 dígitos y coma al final, es formato colombiano
                        // Ejemplo: 69.630.000,00 -> puntos son miles, coma es decimal

                        const hasCommaAsThousands = /,\d{3}/.test(cleanValue);
                        const hasDotAsThousands = /\.\d{3}[,.]/.test(cleanValue) || /\.\d{3}\.\d{3}/.test(cleanValue);

                        if (hasCommaAsThousands) {
                            // Formato US/Gravity: 69,630,000.00
                            // Remover comas (separadores de miles), mantener punto decimal
                            cleanValue = cleanValue.replace(/,/g, '');
                        } else if (hasDotAsThousands) {
                            // Formato Colombiano: 69.630.000,00
                            // Remover puntos (separadores de miles), convertir coma a punto decimal
                            cleanValue = cleanValue.replace(/\./g, '').replace(/,/g, '.');
                        } else {
                            // Formato simple sin separadores de miles
                            // Solo manejar posible coma decimal
                            cleanValue = cleanValue.replace(/,/g, '.');
                        }

                        return parseFloat(cleanValue) || 0;
                    }

                    function formatCurrency(value) {
                        return new Intl.NumberFormat('es-CO', {
                            style: 'currency',
                            currency: 'COP',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(value);
                    }

                    function formatNumber(value) {
                        return new Intl.NumberFormat('es-CO', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(value);
                    }

                    function getFormDataAndCalculate() {
                        // Get form values from Gravity Forms fields with specified CSS classes
                        const monthlyIncomeField = gravityForm.querySelector('.gf-monthly-income input');
                        const termInMonthsField = gravityForm.querySelector('.gf-term-in-months select');
                        const economicActivityField = gravityForm.querySelector('.gf-economic-activity input[type="text"]');
                        const downPaymentField = gravityForm.querySelector('.gf-down-payment-amount input[type="text"]');

                        console.log('DEBUG - Fields found:', {
                            monthlyIncomeField: monthlyIncomeField,
                            termInMonthsField: termInMonthsField,
                            economicActivityField: economicActivityField,
                            downPaymentField: downPaymentField
                        });

                        console.log('DEBUG - Raw values:', {
                            monthlyIncome: monthlyIncomeField ? monthlyIncomeField.value : 'NULL',
                            termInMonths: termInMonthsField ? termInMonthsField.value : 'NULL',
                            economicActivity: economicActivityField ? economicActivityField.value : 'NULL',
                            downPayment: downPaymentField ? downPaymentField.value : 'NULL'
                        });

                        // Clean and parse numeric values from text inputs
                        const monthlyIncomeValue = monthlyIncomeField ? cleanCurrencyValue(monthlyIncomeField.value) : 0;
                        const termInMonthsValue = termInMonthsField ? parseInt(termInMonthsField.value.toString().replace(/[^0-9]/g, '')) || 0 : 0;
                        const downPaymentValue = downPaymentField ? cleanCurrencyValue(downPaymentField.value) : 0;

                        let calculationData = {
                            monthlyIncome: monthlyIncomeValue,
                            termInMonths: termInMonthsValue,
                            economicActivity: economicActivityField ? economicActivityField.value : '',
                            downPaymentAmount: downPaymentValue,
                            vehiclePrice: window.selectedVehicle ? parseFloat(window.selectedVehicle.price) : 0
                        };

                        console.log('DEBUG - Parsed calculationData:', calculationData);

                        // Calculate loan payment if we have valid data
                        if (calculationData.vehiclePrice > 0 && calculationData.termInMonths > 0) {
                            // Tasa de interés mensual según Excel: 1.83%
                            const monthlyInterestRate = 1.83;

                            const calculation = calcularCuotaCredito(
                                calculationData.vehiclePrice,
                                monthlyInterestRate,
                                calculationData.downPaymentAmount,
                                calculationData.termInMonths
                            );

                            console.log('DEBUG - Calculation result:', calculation);

                            calculationData.calculation = calculation;
                            calculationData.monthlyInterestRate = monthlyInterestRate;
                            // El monto financiado total incluye AVAL e IVA
                            calculationData.financedAmount = calculation.valorFinanciarTotal || (calculationData.vehiclePrice - calculationData.downPaymentAmount);
                        } else {
                            console.warn('DEBUG - Cannot calculate, missing data:', {
                                vehiclePrice: calculationData.vehiclePrice,
                                termInMonths: calculationData.termInMonths
                            });
                        }

                        console.log('DEBUG - Final calculationData:', calculationData);
                        return calculationData;
                    }

                    function updateStep3WithCalculation(calculationData) {
                        if (window.selectedVehicle) {
                            const step3VehicleName = step3.querySelector('.vehicle-name-step3');
                            const step3VehicleImage = step3.querySelector('.vehicle-image');

                            if (step3VehicleName) {
                                step3VehicleName.textContent = window.selectedVehicle.name;
                            }
                            if (step3VehicleImage) {
                                step3VehicleImage.src = window.selectedVehicle.image;
                            }
                        }

                        // Update calculation results in step 3
                        if (calculationData.calculation && !calculationData.calculation.error) {
                            // Update interest rate (first div)
                            const interestRateElement = step3.querySelector('.grid div:nth-child(1) .heading-small p');
                            if (interestRateElement) {
                                interestRateElement.textContent = calculationData.monthlyInterestRate + '%';
                            }

                            // Update monthly payment (second div)
                            const monthlyPaymentElement = step3.querySelector('.grid div:nth-child(2) .heading-small p');
                            if (monthlyPaymentElement) {
                                monthlyPaymentElement.textContent = formatCurrency(calculationData.calculation.cuotaMensual);
                            }

                            // Update financed amount (third div)
                            const financedAmountElement = step3.querySelector('.grid div:nth-child(3) .heading-small p');
                            if (financedAmountElement) {
                                financedAmountElement.textContent = formatCurrency(calculationData.financedAmount);
                            }

                            // Update term in months (fourth div)
                            const termElement = step3.querySelector('.grid div:nth-child(4) .heading-small p');
                            if (termElement) {
                                termElement.textContent = calculationData.termInMonths.toString();
                            }
                        }
                    }

                    function collectFormFieldValues() {
                        const data = {};

                        // Nombre completo (campo name, sub-field first name 1.3)
                        const nameField = document.getElementById('input_2_1_3') || gravityForm.querySelector('[id*="_1_3"][type="text"]');
                        data.fullname = nameField ? nameField.value.trim() : '';

                        // Email (field ID 2)
                        const emailField = document.getElementById('input_2_2') || gravityForm.querySelector('input[type="email"]');
                        data.email = emailField ? emailField.value.trim() : '';

                        // Celular (field ID 5)
                        const phoneField = document.getElementById('input_2_5') || gravityForm.querySelector('input[type="tel"]');
                        data.cellphone = phoneField ? phoneField.value.trim() : '';

                        // Ciudad (field ID 1005)
                        const cityField = document.getElementById('input_2_1005') || gravityForm.querySelector('[id*="_1005"]');
                        data.city = cityField ? cityField.value.trim() : '';

                        // Sucursal (field ID 1006)
                        const sucursalField = document.getElementById('input_2_1006') || gravityForm.querySelector('select[id*="_1006"]');
                        data.sucursal = sucursalField ? sucursalField.value.trim() : '';

                        // Actividad económica (field ID 14)
                        const activityField = gravityForm.querySelector('.gf-economic-activity input[type="text"]');
                        data.economic_activity = activityField ? activityField.value.trim() : '';

                        // Tipo empleo (radio field ID 12)
                        const employmentField = gravityForm.querySelector('input[name="input_12"]:checked');
                        data.employment_type = employmentField ? employmentField.value.trim() : '';

                        return data;
                    }

                    function formatNumberForPilot(value) {
                        if (!value && value !== 0) return '';
                        return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(value));
                    }

                    function sendToPilot(formData, calculationData) {
                        if (typeof window.yamavallePilot === 'undefined') {
                            console.error('Yamavalle Pilot: configuración no disponible');
                            return;
                        }

                        const payload = new FormData();
                        payload.append('action', 'yamavalle_send_to_pilot');
                        payload.append('nonce', window.yamavallePilot.nonce);

                        // Datos personales
                        payload.append('fullname', formData.fullname);
                        payload.append('email', formData.email);
                        payload.append('cellphone', formData.cellphone);
                        payload.append('city', formData.city);
                        payload.append('sucursal', formData.sucursal);
                        payload.append('economic_activity', formData.economic_activity);
                        payload.append('employment_type', formData.employment_type);

                        // Vehículo
                        payload.append('vehicle_name', window.selectedVehicle ? window.selectedVehicle.name : '');
                        payload.append('vehicle_price', formatNumberForPilot(window.selectedVehicle ? window.selectedVehicle.price : 0));

                        // Datos financieros
                        payload.append('monthly_income', formatNumberForPilot(calculationData.monthlyIncome));
                        payload.append('down_payment', formatNumberForPilot(calculationData.downPaymentAmount));
                        payload.append('term_months', calculationData.termInMonths || '');

                        // Resultados del cálculo
                        if (calculationData.calculation && !calculationData.calculation.error) {
                            payload.append('monthly_payment', formatNumberForPilot(calculationData.calculation.cuotaMensual));
                            payload.append('financed_amount', formatNumberForPilot(calculationData.financedAmount));
                            payload.append('interest_rate', calculationData.monthlyInterestRate || '');
                            payload.append('aval', formatNumberForPilot(calculationData.calculation.aval));
                            payload.append('iva_aval', formatNumberForPilot(calculationData.calculation.ivaAval));
                        }

                        // UI feedback
                        const btn = step3.querySelector('.pilot-contact-btn');
                        const msgContainer = step3.querySelector('.pilot-message');
                        if (btn) {
                            btn.disabled = true;
                            btn.textContent = 'Enviando tu solicitud...';
                        }
                        if (msgContainer) {
                            msgContainer.style.display = 'none';
                        }

                        fetch(window.yamavallePilot.ajax_url, {
                            method: 'POST',
                            body: payload
                        })
                        .then(function(response) { return response.json(); })
                        .then(function(result) {
                            if (result.success) {
                                if (btn) {
                                    btn.textContent = '¡Solicitud enviada!';
                                    btn.style.background = '#16a34a';
                                    btn.style.borderColor = '#16a34a';
                                }
                                if (msgContainer) {
                                    msgContainer.innerHTML = '<span class="pilot-success-icon">&#10003;</span><br><strong>¡Excelente! Hemos recibido tu solicitud.</strong><br>Uno de nuestros asesores se comunicará contigo pronto para ayudarte a conseguir tu moto ideal.';
                                    msgContainer.className = 'pilot-message pilot-success';
                                    msgContainer.style.display = 'block';
                                }
                                // Ocultar la card CTA para dar protagonismo al mensaje
                                var ctaCard = step3.querySelector('.pilot-cta-card');
                                if (ctaCard) ctaCard.style.display = 'none';
                            } else {
                                if (btn) {
                                    btn.disabled = false;
                                    btn.textContent = 'Solicitar asesoría personalizada';
                                }
                                if (msgContainer) {
                                    msgContainer.textContent = result.data ? result.data.message : 'No pudimos procesar tu solicitud. Por favor intenta de nuevo.';
                                    msgContainer.className = 'pilot-message pilot-error';
                                    msgContainer.style.display = 'block';
                                }
                            }
                        })
                        .catch(function(error) {
                            console.error('Yamavalle Pilot error:', error);
                            if (btn) {
                                btn.disabled = false;
                                btn.textContent = 'Solicitar asesoría personalizada';
                            }
                            if (msgContainer) {
                                msgContainer.textContent = 'Error de conexión. Por favor intenta de nuevo.';
                                msgContainer.className = 'pilot-message pilot-error';
                                msgContainer.style.display = 'block';
                            }
                        });
                    }

                    function injectContactButton() {
                        // No inyectar si ya existe
                        if (step3.querySelector('.pilot-contact-container')) return;

                        const container = document.createElement('div');
                        container.className = 'pilot-contact-container';

                        container.innerHTML = `
                            <div class="pilot-cta-card">
                                <p class="pilot-cta-title">¿Te interesa esta moto?</p>
                                <p class="pilot-cta-subtitle">Un asesor experto te contactará para resolver tus dudas y ayudarte con el proceso de financiación.</p>
                                <button type="button" class="pilot-contact-btn">Solicitar asesoría personalizada</button>
                                <p class="pilot-cta-hint">Sin compromiso · Respuesta en menos de 24 horas</p>
                            </div>
                            <div class="pilot-message" style="display: none;"></div>
                        `;

                        // Insertar justo después del grid de resultados (Tasa, Cuota, etc.)
                        // dentro del space-y-8 que contiene los datos de la cotización
                        const resultsGrid = step3.querySelector('.grid.grid-cols-1');
                        if (resultsGrid && resultsGrid.parentElement) {
                            // Insertar después del grid, dentro del mismo contenedor space-y-8
                            resultsGrid.parentElement.appendChild(container);
                        } else {
                            // Fallback: insertar antes del botón "Volver"
                            const backBtn = step3.querySelector('button[data-step="1"]');
                            if (backBtn && backBtn.parentElement) {
                                backBtn.parentElement.insertBefore(container, backBtn);
                            } else {
                                step3.appendChild(container);
                            }
                        }

                        // Agregar estilos dinámicos
                        if (!document.getElementById('pilot-contact-styles')) {
                            const style = document.createElement('style');
                            style.id = 'pilot-contact-styles';
                            style.textContent = `
                                .pilot-contact-container {
                                    margin-top: 8px;
                                }
                                .pilot-cta-card {
                                    border-top: 2px solid var(--primary-color, #e30613);
                                    padding: 20px 0 0;
                                }
                                .pilot-cta-title {
                                    font-size: 1.8rem;
                                    font-weight: 700;
                                    color: #1a1a1a;
                                    margin: 0 0 6px;
                                    font-family: var(--font-russo, sans-serif);
                                    text-transform: uppercase;
                                    letter-spacing: 1px;
                                }
                                .pilot-cta-subtitle {
                                    font-size: 1.3rem;
                                    color: #555;
                                    margin: 0 0 16px;
                                    line-height: 1.5;
                                }
                                .pilot-contact-btn {
                                    display: inline-block;
                                    background: var(--primary-color, #e30613);
                                    color: #fff;
                                    border: 2px solid var(--primary-color, #e30613);
                                    padding: 14px 36px;
                                    font-size: 1.5rem;
                                    font-weight: 600;
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    text-transform: uppercase;
                                    letter-spacing: 1px;
                                    font-family: var(--font-russo, sans-serif);
                                    transform: skewX(-12deg);
                                }
                                .pilot-contact-btn:hover:not(:disabled) {
                                    background: transparent;
                                    color: var(--primary-color, #e30613);
                                }
                                .pilot-contact-btn:disabled {
                                    opacity: 0.7;
                                    cursor: not-allowed;
                                    transform: skewX(-12deg);
                                }
                                .pilot-cta-hint {
                                    font-size: 1.1rem;
                                    color: #999;
                                    margin: 10px 0 0;
                                }
                                .pilot-message {
                                    margin-top: 12px;
                                    padding: 14px 16px;
                                    font-size: 1.3rem;
                                }
                                .pilot-success {
                                    background: #f0fdf4 !important;
                                    color: #166534 !important;
                                    border-left: 3px solid #16a34a;
                                    border-top: 1px solid #bbf7d0;
                                    border-bottom: 1px solid #bbf7d0;
                                    border-right: 1px solid #bbf7d0;
                                }
                                .pilot-success .pilot-success-icon {
                                    display: inline-block;
                                    font-size: 2.4rem;
                                    margin-bottom: 6px;
                                }
                                .pilot-error {
                                    background: #fef2f2 !important;
                                    color: #991b1b !important;
                                    border-left: 3px solid #dc2626;
                                    border-top: 1px solid #fecaca;
                                    border-bottom: 1px solid #fecaca;
                                    border-right: 1px solid #fecaca;
                                }
                            `;
                            document.head.appendChild(style);
                        }
                    }

                    function proceedToNextStep() {
                        // Get form data and calculate before proceeding
                        const calculationData = getFormDataAndCalculate();

                        // Capturar datos del formulario GF ANTES de ocultar step 2
                        const formFieldValues = collectFormFieldValues();

                        step2.classList.add('hidden');
                        step3.classList.remove('hidden');
                        updateMenuStep(3);

                        updateStep3WithCalculation(calculationData);

                        // Inyectar botón "Quiero ser contactado" en step 3
                        injectContactButton();

                        // Configurar evento del botón
                        const contactBtn = step3.querySelector('.pilot-contact-btn');
                        if (contactBtn) {
                            // Remover listener anterior si existe (por si vuelve al step 3)
                            const newBtn = contactBtn.cloneNode(true);
                            contactBtn.parentNode.replaceChild(newBtn, contactBtn);

                            newBtn.addEventListener('click', function() {
                                sendToPilot(formFieldValues, calculationData);
                            });
                        }

                        if (window.innerWidth <= 767) {
                            setTimeout(() => {
                                step3.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }, 500);
                        }
                    }

                    if (typeof gform !== 'undefined' && typeof gform.doAction === 'function') {
                        // Llenar el campo oculto con el nombre del vehículo
                        if (window.selectedVehicle && window.selectedVehicle.name) {
                            const vehicleNameField = gravityForm.querySelector('input[name="input_998"]');
                            if (vehicleNameField) {
                                vehicleNameField.value = window.selectedVehicle.name;
                            }
                        }

                        gform.doAction('gform_pre_submission', gravityForm, {});

                        const formData = new FormData(gravityForm);
                        formData.append('gform_submit', simulator_config.form_id.toString());
                        formData.append(`is_submit_${simulator_config.form_id}`, '1');

                        fetch(gravityForm.action || window.location.href, {
                            method: 'POST',
                            body: formData
                        })
                            .then(response => response.text())
                            .then(html => {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(html, 'text/html');
                                const newForm = doc.querySelector(`form[id="gform_${simulator_config.form_id}"]`);
                                const confirmationMessage = doc.querySelector('.gform_confirmation_wrapper, .gform_confirmation_message');
                                const hasErrors = doc.querySelectorAll('.gfield_error, .validation_error, .gform_validation_error').length > 0;

                                if (confirmationMessage && !hasErrors) {
                                    proceedToNextStep();
                                } else if (hasErrors && newForm) {
                                    gravityForm.innerHTML = newForm.innerHTML;

                                    // Reinitialize telephone field plugin after form update
                                    reinitializeTelephoneFields();

                                    console.log('Form validation failed - errors displayed');
                                } else if (!hasErrors) {
                                    proceedToNextStep();
                                } else {
                                    console.log('Form validation failed');
                                }
                            })
                            .catch(error => {
                                console.error('Error submitting form:', error);
                            });

                    } else {
                        const requiredFields = gravityForm.querySelectorAll('[aria-required="true"], .gfield_contains_required input, .gfield_contains_required select, .gfield_contains_required textarea');
                        let hasEmptyRequired = false;

                        requiredFields.forEach(field => {
                            if (!field.value.trim()) {
                                hasEmptyRequired = true;
                                const fieldContainer = field.closest('.gfield');
                                if (fieldContainer) {
                                    fieldContainer.classList.add('gfield_error');
                                    let errorMsg = fieldContainer.querySelector('.validation_message');
                                    if (!errorMsg) {
                                        errorMsg = document.createElement('div');
                                        errorMsg.className = 'validation_message';
                                        errorMsg.textContent = 'Este campo es obligatorio.';
                                        fieldContainer.appendChild(errorMsg);
                                    }
                                }
                            } else {
                                const fieldContainer = field.closest('.gfield');
                                if (fieldContainer) {
                                    fieldContainer.classList.remove('gfield_error');
                                    const errorMsg = fieldContainer.querySelector('.validation_message');
                                    if (errorMsg) {
                                        errorMsg.remove();
                                    }
                                }
                            }
                        });

                        if (!hasEmptyRequired) {
                            proceedToNextStep();
                        } else {
                            console.log('Required fields are empty');
                        }
                    }

                } else {
                    // Fallback when no Gravity Form is present
                    step2.classList.add('hidden');
                    step3.classList.remove('hidden');
                    updateMenuStep(3);

                    if (window.selectedVehicle) {
                        const step3VehicleName = step3.querySelector('.vehicle-name-step3');
                        const step3VehicleImage = step3.querySelector('.vehicle-image');

                        if (step3VehicleName) {
                            step3VehicleName.textContent = window.selectedVehicle.name;
                        }
                        if (step3VehicleImage) {
                            step3VehicleImage.src = window.selectedVehicle.image;
                        }
                    }

                    // Scroll hacia arriba para mostrar la cotización en mobile
                    if (window.innerWidth <= 767) {
                        setTimeout(() => {
                            step3.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }, 500);
                    }
                }
            });
        }

        const btnAtrasStep3 = step3.querySelector('button[data-step="1"]');
        if (btnAtrasStep3) {
            btnAtrasStep3.addEventListener('click', function () {
                step3.classList.add('hidden');
                step1.classList.remove('hidden');
                updateMenuStep(1);
            });
        }
    }
});

function calcularCuotaCredito(valorMoto, tasaInteresMensual, cuotaInicial, numeroMeses) {
    // 1. Validar la cuota inicial
    if (cuotaInicial < 0 || cuotaInicial > valorMoto) {
        return {
            error: "La cuota inicial no puede ser negativa ni superior al valor de la moto.",
            cuotaMensual: null
        };
    }

    // 2. Calcular el valor a financiar (valor moto - cuota inicial)
    const valorFinanciar = valorMoto - cuotaInicial;

    // 3. Calcular AVAL (10% del valor a financiar) e IVA del AVAL (19%)
    const aval = valorFinanciar * 0.10;
    const ivaAval = aval * 0.19;

    // 4. Valor total a financiar = valor a financiar + AVAL + IVA del AVAL
    const valorFinanciarTotal = valorFinanciar + aval + ivaAval;

    // 5. Convertir la tasa de interés a su valor decimal (ej. 1.83% -> 0.0183)
    const i = tasaInteresMensual / 100;

    // 6. Aplicar la fórmula PAGO de Excel (cuota fija con interés compuesto)
    // PMT = P * i / (1 - (1 + i)^(-n))
    // Esta es la fórmula estándar que usa Excel para calcular pagos de préstamos
    const cuotaMensual = (valorFinanciarTotal * i) / (1 - Math.pow(1 + i, -numeroMeses));

    if (!isFinite(cuotaMensual) || numeroMeses <= 0) {
        return {
            error: "El número de meses debe ser mayor que 0.",
            cuotaMensual: null
        };
    }

    // 7. Devolver el resultado con todos los valores calculados
    return {
        error: null,
        cuotaMensual: cuotaMensual,
        valorFinanciar: valorFinanciar,
        aval: aval,
        ivaAval: ivaAval,
        valorFinanciarTotal: valorFinanciarTotal
    };
}